import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserAllGraduationApplyQueryVariables = Types.Exact<{
  memberNo?: Types.InputMaybe<Types.Scalars['String']['input']>;
  childNo?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetUserAllGraduationApplyQuery = { __typename?: 'Query', club_worldFamilyClub_graduationApplication?: { __typename?: 'Club_WorldFamilyClub_GraduationApplicationConnection', totalCount: number, nodes?: Array<{ __typename?: 'Club_WorldFamilyClub_GraduationApplication', id: string, age?: string | null, applicationDate?: any | null, audioFile?: string | null, childEnglishName?: string | null, childName?: string | null, childNo?: string | null, isExcellent?: boolean | null, market?: string | null, memberNo?: string | null, taskId?: number | null, videoUrl?: string | null, isPassed?: boolean | null, approvalDate?: any | null, overallComment?: string | null, graduationSubApplications?: Array<{ __typename?: 'Club_WorldFamilyClub_GraduationSubApplication', id: string, applicationId?: number | null, subTaskId?: number | null, subTask?: { __typename?: 'Club_WorldFamilyClub_GraduationApplicationSubTask', graduationSubTaskMarketDescriptions?: Array<{ __typename?: 'Club_WorldFamilyClub_GraduationSubTaskMarketDescription', market?: string | null, subTaskId?: number | null, subTaskName?: string | null } | null> | null } | null } | null> | null }> | null } | null };


export const GetUserAllGraduationApplyDocument = gql`
    query getUserAllGraduationApply($memberNo: String, $childNo: String) {
  club_worldFamilyClub_graduationApplication(
    filter: {memberNo: {eq: $memberNo}, childNo: {eq: $childNo}}
    first: 100
  ) {
    totalCount
    nodes {
      id
      age
      applicationDate
      audioFile
      childEnglishName
      childName
      childNo
      isExcellent
      market
      memberNo
      taskId
      videoUrl
      graduationSubApplications {
        id
        applicationId
        subTaskId
        subTask {
          graduationSubTaskMarketDescriptions {
            market
            subTaskId
            subTaskName
          }
        }
      }
      isPassed
      approvalDate
      overallComment
    }
  }
}
    `;

/**
 * __useGetUserAllGraduationApplyQuery__
 *
 * To run a query within a React component, call `useGetUserAllGraduationApplyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAllGraduationApplyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAllGraduationApplyQuery({
 *   variables: {
 *      memberNo: // value for 'memberNo'
 *      childNo: // value for 'childNo'
 *   },
 * });
 */
export function useGetUserAllGraduationApplyQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAllGraduationApplyQuery, GetUserAllGraduationApplyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAllGraduationApplyQuery, GetUserAllGraduationApplyQueryVariables>(GetUserAllGraduationApplyDocument, options);
      }
export function useGetUserAllGraduationApplyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAllGraduationApplyQuery, GetUserAllGraduationApplyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAllGraduationApplyQuery, GetUserAllGraduationApplyQueryVariables>(GetUserAllGraduationApplyDocument, options);
        }
export type GetUserAllGraduationApplyQueryHookResult = ReturnType<typeof useGetUserAllGraduationApplyQuery>;
export type GetUserAllGraduationApplyLazyQueryHookResult = ReturnType<typeof useGetUserAllGraduationApplyLazyQuery>;
export type GetUserAllGraduationApplyQueryResult = Apollo.QueryResult<GetUserAllGraduationApplyQuery, GetUserAllGraduationApplyQueryVariables>;